/**
 * Customer Alert Flags — visual metadata for the closed set of alert
 * identifiers defined in backend/server.py::CUSTOMER_ALERT_FLAGS.
 *
 * When adding a new flag: register it here AND in the backend enum.
 * The frontend never invents its own flag ids.
 *
 * Tone maps to Tailwind classes so all alerts look consistent across
 * the app (banner, chip, editor).
 */

export const CUSTOMER_ALERT_META = {
  credit_hold: {
    label: "Credit Hold",
    description: "AR must clear before delivery",
    tone: "red",
  },
  keep_full: {
    label: "Keep Full",
    description: "Auto-schedule top-ups",
    tone: "blue",
  },
  call_before: {
    label: "Call Before Delivery",
    description: "Phone customer prior to arrival",
    tone: "amber",
  },
  dog_on_property: {
    label: "Dog on Property",
    description: "Driver safety — approach with care",
    tone: "amber",
  },
  south_entrance_only: {
    label: "South Entrance Only",
    description: "Access via south gate",
    tone: "slate",
  },
  gate_code_required: {
    label: "Gate Code Required",
    description: "Coordinate with customer for code",
    tone: "slate",
  },
  restricted_hours: {
    label: "Restricted Hours",
    description: "Deliver within a specific window",
    tone: "amber",
  },
  hazard_on_site: {
    label: "Hazard on Site",
    description: "Driver safety — PPE required",
    tone: "red",
  },
};

// Tone → Tailwind class helper. Same tone should look identical in the
// banner, chip, editor, and Customer Snapshot popover — one source of
// truth.
export const ALERT_TONE_CLASSES = {
  red:   "border-rose-300 bg-rose-50 text-rose-800",
  amber: "border-amber-300 bg-amber-50 text-amber-800",
  blue:  "border-sky-300 bg-sky-50 text-sky-800",
  slate: "border-slate-300 bg-slate-100 text-slate-700",
};

export function alertMeta(flagId) {
  return CUSTOMER_ALERT_META[flagId] || {
    label: flagId,
    description: "",
    tone: "slate",
  };
}
